<template>
  <main class="page-content mb-auto w-100 text-center" aria-label="Content">
    <div class="section-wraper">
      <div class="section-content">
        <section class="section">
          <div class="header">
            <h1>Dein Laden</h1>
          </div>
          <div class="content" v-if="company">
            <div class="content-center-group">
              <div class="atom search-selection mt-3 mb-3">
                <h4 class="text-primary">{{company.name}}</h4>
                <h6 class="font-weight-normal">{{company.address}}</h6>
              </div>
              <div class="mt-4">
                <h3 v-if="total.money != 0">Wird wieder besucht werden</h3>
                <h3 v-if="total.money == 0">
                  Hat leider noch keine Solidaritätsbekundungen
                </h3>
                <div class="p-0 mb-4" v-if="total.money == 0">
                  Teile den Link zu deinem Laden in den sozialen Medien damit deine Kunden darauf aufmerksam werden! 
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="section-wrap-full-width bg-error my-3" v-if="total.money != 0">
      <div class="w-75 text-white analytics-wrapper">
        <div class="content-center-group">
          <i class="stg st-love-heart-hands-hold-3 align-middle align-middle text-white mb-0 pb-0"></i>
          <h2 class="text-white mb-0">{{total.donations}}</h2>
          <small class="mb-0">Leute freuen sich auf deine Wiedereröffnung!</small>
        </div>
      </div>
    </div>

    <div class="center-center-group col-12 col-md-6" style="margin: auto; padding: 0px 48px; margin: auto;">
      <donation-message
        v-for="donationMessage in donationMessages"
        :key="donationMessage.donationUID"
        :userRef="donationMessage.userRef"
        :message="donationMessage.message"
      />
    </div>

    <div class="section-wrap">
      <div class="section-content">
        <section class="section mt-2">
          <div class="content">
            <div class="content-center-group">

              <div class="p-0 mb-4" v-if="total.money != 0">
                Damit deine Kunden auf covida aufmerksam
                werden, teile folgenden Link in den sozialen Medien.
              </div>

              <div class="p-0">Vorschau</div>
              <div class="ticket for-company">
                <div class="left-side">
                  <div class="bg"></div>
                  <div class="badge">
                    <div class="title">
                      CORONA
                      <br />Solidarität
                    </div>
                    <div class="hashtag">#solidarity4kmu</div>
                    <div class="link">www.covida.ch</div>
                  </div>
                </div>
                <div class="right-side text-center" style="margin-top: 0px">
                  <b class="unit my-2" style="font-size: 16px; line-height: 20px;">
                    Lass uns wissen,
                    <br />dass du uns wieder
                    <br />besuchen wirst.
                  </b>
                  <div class="place" style="font-size: 14px">auf: www.covida.ch</div>
                </div>
              </div>
            </div>
           
            <div>
              <div class="p-0 text-black font-weight-bold mt-5">Teile es mit deinen Freunden</div>
              <div class="social-button-group">
                <social-sharing :url=getUrlParam hashtags="solidarity4kmu" inline-template>
                  <div>
                    <network network="facebook">
                      <button class="btn btn-icon facebook">
                        <i class="stg st-social-media-facebook-1"></i>Share on Facebook
                      </button>
                    </network>
                  </div>
                </social-sharing>
                <social-sharing :url=getUrlParam hashtags="solidarity4kmu" inline-template>
                  <div>
                    <network network="twitter">
                      <button class="btn btn-icon twitter">
                        <i class="stg st-social-media-twitter"></i>Share on Twitter
                      </button>
                    </network>
                  </div>
                </social-sharing>
                <social-sharing
                  :url=getUrlParam
                  hashtags="solidarity4kmu"
                  inline-template
                >
                  <div>
                    <network network="whatsapp">
                      <button class="btn btn-icon whatsapp">
                        <i class="stg st-messaging-whatsapp"></i>Share on Whatsapp
                      </button>
                    </network>
                  </div>
                </social-sharing>
              </div>
            </div>
            <div class="p-0 text-black mt-5 mb-4">
              <h3>
                Deine Kunden möchten ein
                Soli-Beitrag zahlen
              </h3>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="section-wrap-full-width bg-error my-3" v-if="total.money != 0">
      <div class="w-75 text-white analytics-wrapper">
        <div class="content-center-group">
          <i class="stg st-space-rocket-flying align-middle text-white mb-0 pb-0"></i>
          <div class="d-flex align-items-center">
            <h2 class="text-white mb-0">{{total.money | toCurrency}}</h2>
          </div>
          <small class="mb-0">Wird mehr bezahlt werden</small>
        </div>
      </div>
    </div>
    <div class="section-wrap">
      <div class="section-content col-12 col-md-8 offset-md-2 mt-4">
        Einige deiner Kunden möchten das nächste mal
        gerne etwas drauf bezahlen. Ob du das möchtest oder nicht entscheidest natürlich du.
        Falls du Hilfe beim Verbuchen brauchen solltest, haben <b style="text-decoration: underline;">wir hier etwas</b> vorbereitet.
      </div>
    </div>
    <div class="purple-wraper">
      <div class="logo-temp">
        <img src="@/assets/img/KLARA_Logo_Square.png" alt />
      </div>
      <div class="purple">
        <div class="section-content">
          <div class="content-center-group">
            <h3 class="text-white">
              Ist das dein Laden?
              Willst du deine Unterstützer
              kennenlernen?
            </h3>
            <div class="p-0 mb-4 text-white">
              Registrier dich jetzt kostenlos auf KLARA und verifizier
              dein
              Unternehmen. Somit wissen wir, dass das
              tatsächlich dein
              Laden ist. Danach können wir dir eine Liste deiner Unterstützer zuschicken. Somit hast du die
              Möglichkeit deine
              Unterstützer zu kontaktieren und zu informieren, sobald dein Laden wieder geöffnet ist.
              <br />Bestimmt möchtest den Leuten, die dir durch diese schwere Zeit helfen auch danke sagen!
            </div>

            <a
              class="btn btn-klara"
              href="https://app.klara.ch/?action=register"
            >Jetzt kostenlos registrieren</a>

            <div class="klara-logo-with-text mx-auto">
              <div class="klara-logo">
                <img src="@/assets/img/KLARA_logo_white.png" alt />
              </div>
            </div>
            <h3 class="text-white">
              In diesen Zeiten ist
              Kundenbindung wichtig!
              KLARA hilft!
            </h3>

            <div class="p-0 mb-4 text-white">
              Um dich jetzt zusätzlich zu unterstützen
              haben wir uns entschieden unser News Modul kostenlos zur Verfügung zu stellen. Registrier dich
              auf KLARA und sag deinen Kunden sie sollen die
              KLARA Regio App herunterladen.
              <br />Du postest News und sie wissen Bescheid.
              Sofort und kostenlos.
            </div>

            <a
              class="btn btn-klara"
              href="https://app.klara.ch/?action=register"
            >Jetzt kostenlos registrieren</a>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import firebase from "firebase/app";

let db = firebase.firestore();
let companiesRef = db.collection("companies");

import DonationMessage from "@/components/DonationMessage.vue";

export default {
  name: "CompanyDetail",
  props: ["companyId"],
  components: {
    donationMessage: DonationMessage
  },
  data: function() {
    return {
      company: null,
      total: {
        money: 0,
        donations: 0
      },
      donationMessages: []
    };
  },
  mounted: function() {
    let $this = this;
    companiesRef
      .doc(this.companyId)
      .get()
      .then(function(storedCompany) {
        if (!storedCompany.exists) {
          $this.$router.push({
            path: "/"
          });
          return;
        }

        $this.company = storedCompany.data();
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      });

    companiesRef
      .doc(this.companyId)
      .collection("donations")
      .onSnapshot(function(querySnapshot) {
        $this.total.donations = 0;
        $this.total.money = 0;
        $this.total.donations += querySnapshot.size;
        querySnapshot.forEach(function(doc) {
          doc
            .data()
            .donationRef.get()
            .then(function(querySnapshot) {
              let donation = querySnapshot.data();
              $this.total.money += donation.value;

              if (!donation.hideMessage && donation.message) {
                $this.donationMessages.push({
                  donationUID: donation.uid,
                  userRef: donation.from,
                  message: donation.message
                });
              }
            })
            .catch(function(error) {
              console.log("Error getting documents: ", error);
            });
        });
      });
  },
  computed: {
    getUrlParam: function () {
          return process.env.VUE_APP_service_sharing_url + "sharing/company";
    }
  },
};
</script>

<style>
</style>
